// extracted by mini-css-extract-plugin
module.exports = {"tip":"src-pages-guide-electronicTaxBureau-components-HubeiEleAuthWrap-HubeiCaAuth-__index__tip--P1kwV"};